import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateAudioPostMutation = createMutationHook(
  MembershipsCreatorApiClient.updateAudioPost,
  {
    mutationKey: ['updateAudioPost'],
  },
)
